(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4646],{

/***/ 33138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ NextShopsPage; }
/* harmony export */ });
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(50029);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _shopify_react_idle__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(17548);
/* harmony import */ var _fh_components_fh_js_api_core_store_slices_shopsSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76137);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14416);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74030);
/* harmony import */ var _lib_handleError__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67408);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70214);
/* harmony import */ var _containers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44420);
/* harmony import */ var _seo_Ecommerce__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31893);
/* harmony import */ var _Shops_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(92835);
/* harmony import */ var _Shops_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_Shops_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var ShopsMap = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 8728).then(__webpack_require__.bind(__webpack_require__, 78728));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components__WEBPACK_IMPORTED_MODULE_6__/* .Loader */ .aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(78728)];
    }
  }
});
var ShopsViews = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 9653).then(__webpack_require__.bind(__webpack_require__, 59653));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components__WEBPACK_IMPORTED_MODULE_6__/* .Loader */ .aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(59653)];
    }
  }
});
function NextShopsPage(props) {
  var _data$shops;

  var _useSelector = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(_fh_components_fh_js_api_core_store_slices_shopsSlice__WEBPACK_IMPORTED_MODULE_4__/* .getShopsData */ .gf),
      data = _useSelector.data;

  var shops = (_data$shops = data === null || data === void 0 ? void 0 : data.shops) !== null && _data$shops !== void 0 ? _data$shops : [];
  var breadcrumbs = [{
    name: 'Магазины',
    slug: 'shops'
  }];
  var setPageType = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function () {
    _seo_Ecommerce__WEBPACK_IMPORTED_MODULE_10__/* ["default"].setPageType */ .ZP.setPageType(_seo_Ecommerce__WEBPACK_IMPORTED_MODULE_10__/* ["default"].PAGE_TYPES.CONTACTS */ .ZP.PAGE_TYPES.CONTACTS);
  }, []);
  (0,_shopify_react_idle__WEBPACK_IMPORTED_MODULE_12__/* .useIdleCallback */ .Y)(setPageType);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_containers__WEBPACK_IMPORTED_MODULE_9__/* .MetaData */ .U4, {
      title: "\u0410\u0434\u0440\u0435\u0441\u0430 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u043E\u0432 FH.BY \u043D\u0430 \u043A\u0430\u0440\u0442\u0435",
      description: "\u0421\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0430\u0445 FH.BY - \u0430\u0434\u0440\u0435\u0441\u0430 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u043E\u0432 \u043D\u0430 \u043A\u0430\u0440\u0442\u0435, \u0444\u043E\u0442\u043E, \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u044B \u0438 \u0432\u0440\u0435\u043C\u044F \u0440\u0430\u0431\u043E\u0442\u044B \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u043E\u0432, \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0445 \u0432 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0435 FH.BY",
      seo: props === null || props === void 0 ? void 0 : props.seo
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_containers__WEBPACK_IMPORTED_MODULE_9__/* .Container */ .W2, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
        className: (_Shops_module_scss__WEBPACK_IMPORTED_MODULE_13___default().tabsContainer),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
          className: (_Shops_module_scss__WEBPACK_IMPORTED_MODULE_13___default().leftSide),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
            className: (_Shops_module_scss__WEBPACK_IMPORTED_MODULE_13___default().breadcrumbs),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_containers__WEBPACK_IMPORTED_MODULE_9__/* .BreadCrumbs */ .bu, {
              breadcrumbs: breadcrumbs
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("h1", {
            className: (_Shops_module_scss__WEBPACK_IMPORTED_MODULE_13___default().title),
            children: props !== null && props !== void 0 && props.seo && props !== null && props !== void 0 && props.seo.h1 ? (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .getCorrectName */ .tx)(props.seo.h1) : 'Магазины'
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(ShopsViews, {
          isStatic: true
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(ShopsMap, _objectSpread(_objectSpread({}, props), {}, {
      shops: shops
    }))]
  });
}

NextShopsPage.getInitialProps = /*#__PURE__*/function () {
  var _ref2 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_ref) {
    var reduxStore, query, _query$latitude, latitude, pageData;

    return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            reduxStore = _ref.reduxStore, query = _ref.query;
            _query$latitude = query.latitude, latitude = _query$latitude === void 0 ? '' : _query$latitude;
            _context.next = 4;
            return reduxStore.dispatch((0,_fh_components_fh_js_api_core_store_slices_shopsSlice__WEBPACK_IMPORTED_MODULE_4__/* .fetchShops */ .NB)());

          case 4:
            pageData = (0,_fh_components_fh_js_api_core_store_slices_shopsSlice__WEBPACK_IMPORTED_MODULE_4__/* .getShopsData */ .gf)(reduxStore.getState());
            (0,_lib_handleError__WEBPACK_IMPORTED_MODULE_7__/* .handleError */ .S)(pageData.error);
            return _context.abrupt("return", {
              latitude: latitude
            });

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),

/***/ 62321:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shops",
      function () {
        return __webpack_require__(33138);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92835:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Shops_breadcrumbs__u4c0X","title":"Shops_title__GNmAy","tabsContainer":"Shops_tabsContainer__W62Jb","load":"Shops_load__8roMN"};

/***/ }),

/***/ 17548:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ useIdleCallback; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@shopify/react-idle/build/esm/types.mjs
let UnsupportedBehavior;

(function (UnsupportedBehavior) {
  UnsupportedBehavior[UnsupportedBehavior["Immediate"] = 0] = "Immediate";
  UnsupportedBehavior[UnsupportedBehavior["AnimationFrame"] = 1] = "AnimationFrame";
})(UnsupportedBehavior || (UnsupportedBehavior = {}));



;// CONCATENATED MODULE: ./node_modules/@shopify/react-idle/build/esm/hooks.mjs



function useIdleCallback(callback, {
  unsupportedBehavior = UnsupportedBehavior.AnimationFrame
} = {}) {
  const handle = (0,react.useRef)(null);
  (0,react.useEffect)(() => {
    if ('requestIdleCallback' in window) {
      handle.current = window.requestIdleCallback(() => callback());
    } else if (unsupportedBehavior === UnsupportedBehavior.AnimationFrame) {
      handle.current = window.requestAnimationFrame(() => {
        callback();
      });
    } else {
      callback();
    }

    return () => {
      const {
        current: currentHandle
      } = handle;
      handle.current = null;

      if (currentHandle == null) {
        return;
      }

      if ('cancelIdleCallback' in window) {
        window.cancelIdleCallback(currentHandle);
      } else if (unsupportedBehavior === UnsupportedBehavior.AnimationFrame) {
        window.cancelAnimationFrame(currentHandle);
      }
    };
  }, [callback, unsupportedBehavior]);
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(62321); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);